import { WaitlistForm } from "@/components/WaitlistForm";
import { HoundNote } from "@/components/HoundNote";
import { Paw } from "@/components/Paw";

const IMG_ONE = "https://customer-assets.emergentagent.com/job_george-henry-co/artifacts/7r634zry_George%20Portrait.jpg";
const IMG_TWO = "https://customer-assets.emergentagent.com/job_george-henry-co/artifacts/s709ux81_Henry%20Portrait.jpg";
const IMG_THREE = "https://customer-assets.emergentagent.com/job_george-henry-co/artifacts/yg2t0glp_Henry%20and%20George.jpg";

export default function About() {
  return (
    <div className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[1100px]" aria-hidden="true">
        <div className="absolute -top-28 -left-24 w-[28rem] h-[28rem] rounded-full bg-rosegold/20 blur-3xl" />
        <div className="absolute top-24 right-1/4 w-80 h-80 rounded-full bg-[#F3C6D1]/50 blur-3xl" />
        <div className="absolute top-[460px] -right-10 w-96 h-96 rounded-full bg-[#F3C6D1]/25 blur-3xl" />
        <div className="absolute top-[320px] left-1/4 w-80 h-80 rounded-full bg-white/60 blur-3xl" />
      </div>
      <section className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 pt-16 pb-10 text-center">
        <p className="text-xs uppercase tracking-[0.25em] text-rosegold mb-4">About Hound Oz</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-maroon leading-tight">
          Inspired by two basset hounds, and a love of cosy things.
        </h1>
      </section>

      <section className="relative z-10 max-w-6xl mx-auto px-5 sm:px-8 py-10 grid md:grid-cols-3 gap-4">
        <div className="md:mt-12">
          <div className="rounded-3xl overflow-hidden aspect-[3/4]">
            <img src={IMG_ONE} alt="George in the Hound Oz beanie" className="w-full h-full object-cover" />
          </div>
          <div className="mt-4 text-center">
            <p className="font-bubble font-bold text-maroon text-xl">George</p>
            <p className="text-sm text-inkbrown/60 mt-0.5">Chief Comfort Officer</p>
          </div>
        </div>
        <div>
          <div className="rounded-3xl overflow-hidden aspect-[3/4]">
            <img src={IMG_TWO} alt="Henry in the Hound Oz jumper" className="w-full h-full object-cover" />
          </div>
          <div className="mt-4 text-center">
            <p className="font-bubble font-bold text-maroon text-xl">Henry</p>
            <p className="text-sm text-inkbrown/60 mt-0.5">Head of Quality Control</p>
          </div>
        </div>
        <div className="md:mt-12">
          <div className="rounded-3xl overflow-hidden aspect-[3/4]">
            <img src={IMG_THREE} alt="George and Henry together" className="w-full h-full object-cover" />
          </div>
          <div className="mt-4 text-center">
            <p className="font-bubble font-bold text-maroon text-xl">George &amp; Henry</p>
            <p className="text-sm text-inkbrown/60 mt-0.5">Full-Time Nappers</p>
          </div>
        </div>
      </section>

      <section className="relative z-10 max-w-3xl mx-auto px-5 sm:px-8 py-14 space-y-8 text-inkbrown/80 leading-relaxed text-lg">
        <p>
          HOUND Oz started, quite literally, with a trip to the dog park.
        </p>
        <p>
          I had the usual dog-mum essentials — lead, treats, poop bags, water, phone… and probably
          enough snacks to survive a small emergency. All shoved into a plain bag that did the job
          but definitely wasn't ideal.
        </p>
        <p>
          So, naturally, I went home and searched for the perfect dog-walking bag. Something
          stylish, practical and made for life with dogs.
        </p>
        <p>
          I couldn't find it.
        </p>
        <p>
          And apparently, instead of accepting that, I decided to start a business.
        </p>
        <p>
          What began as an idea for one really good dog-walking bag quickly became something much
          bigger.
        </p>
        <p>
          Enter <span className="text-maroon font-medium">George &amp; Henry</span> — my two basset
          hounds, professional couch warmers, snack enthusiasts and the very handsome inspiration
          behind HOUND Oz.
        </p>
        <p>
          I wanted to create pieces that felt like us: comfortable, effortless, a little bit boujee
          and made for real life with your dog. Think oversized fits, beautiful fabrics and the kind
          of clothes you throw on for a coffee run, a long walk, a weekend adventure… or when that
          "quick cuddle on the couch" somehow turns into three hours.
        </p>
        <p>
          HOUND Oz is for the people whose dogs aren't just dogs. They're part of the family, part
          of the plans and, if we're being truthful, probably running the household.
        </p>
        <p className="font-display text-2xl text-maroon flex items-center gap-2">
          Made for you. Inspired by them.
          <Paw className="w-6 h-6 text-maroon inline-block" />
        </p>
        <p>
          Welcome to HOUND Oz. We're so glad you found us.
        </p>
        <p>
          George &amp; Henry are too. Mostly because they assume there are treats involved.
        </p>

        <HoundNote
          author="George & Henry"
          message="We nap-test every sweater and zoomie-test every fit. If it's not oversized, soft and treat-approved, it doesn't make the cut. Quality is our thing (treat quality too)."
          className="-rotate-1"
        />
      </section>

      <section className="relative z-10 bg-subtle py-20">
        <div className="max-w-2xl mx-auto px-5 sm:px-8 text-center">
          <h2 className="font-display text-3xl text-maroon">Come join the pack</h2>
          <p className="mt-4 text-inkbrown/70">Sign up for cosy updates, new drops and stories from George &amp; Henry.</p>
          <div className="mt-8 flex justify-center">
            <WaitlistForm source="about-page" />
          </div>
        </div>
      </section>
    </div>
  );
}
